import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';

import { FastShippingBanner } from '../components/FastShippingBanner';
import { useFastShippingBannerService } from '../services/useFastShippingBannerService';

export const FastShippingBannerContainer: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { noticeBanner, handleClickBanner } = useFastShippingBannerService();

  if (!noticeBanner) {
    return null;
  }
  return (
    <>
      <Divider />
      <FastShippingBanner noticeBanner={noticeBanner} handleClickBanner={handleClickBanner} />
    </>
  );
};

const Divider = styled.div`
  width: 100%;
  height: 8px;
  background: ${vars.v3Color.gray100};
`;
